//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'goods_drawer',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  computed: {
    goodsList: function goodsList() {
      return this.value.default_value;
      // return this.value.config.id ? this.value.default_value : []
    }
  }
};